import React from "react";
import PropTypes from "prop-types";
import { MenuList, MenuItem } from "material-ui/Menu";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";
import { ListItemIcon, ListItemText } from "material-ui/List";
import departureIcon from "../../../icons/departure.svg";
import destinationIcon from "../../../icons/destination.svg";

const styles = theme => ({
  menuItem: {
    "&:focus": {
      background: theme.palette.primary[500],
      "& $text, & $icon": {
        color: theme.palette.common.white
      }
    }
  },
  text: {},
  icon: {}
});

const MenuMap = props => {
  const { classes } = props;

  return (
    <Paper style={props.contextMenuStyle}>
      <MenuList>
        <MenuItem
          onClick={() => props.onOptionSelect("departure")}
          className={classes.menuItem}
        >
          <ListItemIcon className={classes.icon}>
            <img alt="departure" src={departureIcon} />
          </ListItemIcon>
          <ListItemText
            classes={{ text: classes.text }}
            inset
            primary="A partir de ce lieu"
          />
        </MenuItem>
        {props.modeTabs !== "boucle" && (
          <MenuItem
            onClick={() => props.onOptionSelect("destination")}
            className={classes.menuItem}
          >
            <ListItemIcon className={classes.icon}>
              <img alt="departure" src={destinationIcon} />
            </ListItemIcon>
            <ListItemText
              classes={{ text: classes.text }}
              inset
              primary="Vers ce lieu"
            />
          </MenuItem>
        )}
      </MenuList>
    </Paper>
  );
};

MenuMap.propTypes = {
  classes: PropTypes.shape().isRequired,
  contextMenuStyle: PropTypes.shape().isRequired,
  modeTabs: PropTypes.string.isRequired
};

export default withStyles(styles)(MenuMap);



// WEBPACK FOOTER //
// ./src/containers/Map/MenuMap/MenuMap.jsx